var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouritesNewsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_493_200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#007ECA",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#007ECA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6602 11.9899C25.0202 10.1899 21.7602 11.0299 20.0002 13.0899C18.2402 11.0299 14.9802 10.1799 12.3402 11.9899C10.9402 12.9499 10.0602 14.5699 10.0002 16.2799C9.86021 20.1599 13.3002 23.2699 18.5502 28.0399L18.6502 28.1299C19.4102 28.8199 20.5802 28.8199 21.3402 28.1199L21.4502 28.0199C26.7002 23.2599 30.1302 20.1499 30.0002 16.2699C29.9402 14.5699 29.0602 12.9499 27.6602 11.9899ZM20.1002 26.5499L20.0002 26.6499L19.9002 26.5499C15.1402 22.2399 12.0002 19.3899 12.0002 16.4999C12.0002 14.4999 13.5002 12.9999 15.5002 12.9999C17.0402 12.9999 18.5402 13.9899 19.0702 15.3599H20.9402C21.4602 13.9899 22.9602 12.9999 24.5002 12.9999C26.5002 12.9999 28.0002 14.4999 28.0002 16.4999C28.0002 19.3899 24.8602 22.2399 20.1002 26.5499Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_493_200",
    x: -4,
    y: -4,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_493_200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_493_200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouritesNewsIcon);
export default __webpack_public_path__ + "static/media/favouritesNewsIcon.a880706278c47ae69a7fbe886fb1e05a.svg";
export { ForwardRef as ReactComponent };